import e from './style.module.css';

export const SkeTable = ({ col, row, className }: ISkeTable) => {
  const columns: number[] = Array(col).fill(0);
  const rows: number[] = Array(row).fill(0);
  
  return (<>
    <table className={`${e.tg} ${className}`}>
        <thead>
          <tr>
            {columns.map((_, i) => (
              <th key={`th_${i}`} className={e.tg_cly1}>
                <div className={e.line} />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((_, i) => (
            <tr key={`tr_${i}`}>
              {columns.map((_, i) => (
                <td key={`td_${i}`} className={e.tg_cly1}>
                  <div className={e.line} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </>
  )
}

interface ISkeTable {
  col: number;
  row: number;
  className?: string;
}